import * as React from 'react';
import Axios from 'axios';
import { Modal } from 'react-bootstrap';

import errorReporter from '@app/errorReporter';
import { AnsweringOrgGroupDoc, OrgDoc } from '@bb/domain/dist/schemas';
import type { JsonObject } from '@/app-package';
import Loading from '../../react-common/Loading';
import AddBrokerageGroupInput from './AddBrokerageGroupInput';
import ManageGroupListRow from './ManageGroupListRow';

interface BrokerageSettingsAddModalProps {
  closeModal: () => void;
  fetchGroups: (setFetching?: boolean) => void;
  groups: (Omit<JsonObject<AnsweringOrgGroupDoc>, 'orgs'> & {
    orgs: JsonObject<OrgDoc>[];
  })[];
  visible: boolean;
  fetching: boolean;
}

interface BrokerageSettingsAddModalState {
  input: string;
  loading: boolean;
}

class BrokerageSettingsAddModal extends React.Component<
  BrokerageSettingsAddModalProps,
  BrokerageSettingsAddModalState
> {
  constructor(props: BrokerageSettingsAddModalProps) {
    super(props);
    this.state = { input: '', loading: false };
  }

  public handleInput = (ev: React.ChangeEvent<HTMLInputElement>) => {
    this.setState({ input: ev.target.value });
  };

  public handleAddGroup = async () => {
    const { input } = this.state;
    const { closeModal, fetchGroups } = this.props;

    try {
      this.setState({ loading: true });
      await Axios.post('/answering/groups', { label: input });
      await fetchGroups();
    } catch (err) {
      errorReporter.error(`Error adding a group: ${err}`);
    } finally {
      await closeModal();
    }
  };

  public render() {
    const { closeModal, fetching, groups, visible, fetchGroups } = this.props;
    return (
      <Modal data-cy="modal-popup" show={visible} onHide={closeModal}>
        <div className="color-line"></div>
        <Modal.Header closeButton>
          <Modal.Title>Manage Groups</Modal.Title>
        </Modal.Header>
        <Modal.Body
          style={{ display: 'flex', flexWrap: 'wrap', minHeight: '300px' }}
        >
          <>
            <AddBrokerageGroupInput fetchGroups={fetchGroups} />
            {fetching ? (
              <Loading size="fa-5x" />
            ) : (
              <ul
                className="list-group"
                style={{ width: '100%', marginTop: '2em', marginBottom: '2em' }}
              >
                {groups.map(group => (
                  <ManageGroupListRow
                    key={group.id}
                    group={group}
                    fetchGroups={fetchGroups}
                  />
                ))}
              </ul>
            )}
          </>
        </Modal.Body>
        <Modal.Footer>
          <button
            type="button"
            className="btn btn-default"
            onClick={closeModal}
          >
            Close
          </button>
        </Modal.Footer>
      </Modal>
    );
  }
}

export default BrokerageSettingsAddModal;
